import { Button } from "@mui/material";

const ACRButton = ({ label, onClickButton, style }) => {
  return (
    <Button sx={style} onClick={onClickButton}>
      {label}
    </Button>
  );
};

export default ACRButton;
